import { motion } from 'framer-motion';
import './home.css';

const Home = ({ pageRef, onContactClick }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: [0.6, 0.05, 0.01, 0.9]
      }
    }
  };

  const floatingVariants = {
    animate: {
      y: [0, -15, 0],
      transition: {
        duration: 6,
        repeat: Infinity,
        ease: "easeInOut",
        repeatType: "loop"
      }
    }
  };

  return (
    <div ref={pageRef} className="hero-section">
      <motion.div
        className="hero-content"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1 className="hero-title" variants={itemVariants}>
          Don't code,
          <br />
          <span className="gradient-text">do business!</span>
        </motion.h1>

        <motion.p className="hero-subtitle" variants={itemVariants}>
          Our work is not just about writing the code. Our goal is to work through
          the entire software development cycle with you and to establish an engineering
          culture for your project, using the best practices and technologies that will
          allow you to grow and scale faster.
        </motion.p>

        <motion.div className="hero-cta" variants={itemVariants}>
          <button
            onClick={onContactClick}
            className="btn-primary"
          >
            Start Your Project
          </button>
          <button
            onClick={() => {
              const offerSection = document.getElementById('offer');
              if (offerSection) {
                offerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            className="btn-secondary"
          >
            Learn More
          </button>
        </motion.div>
      </motion.div>

      <motion.div
        className="floating-shapes"
        variants={floatingVariants}
        animate="animate"
      >
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </motion.div>
    </div>
  )
}

export default Home;
